module.exports = __webpack_public_path__ + "static/media/icon-electric.2b2d565d.svg";